import { Box, BoxProps } from '@mui/material';
import React, { forwardRef } from 'react';

interface IProps extends BoxProps {
  testID?: string;
  component?: React.ElementType<any, any>;
}

const EDBox: React.FC<React.PropsWithChildren<IProps>> = forwardRef(
  (props, ref) => {
    const { testID, children, component, ...rest } = props;
    return (
      <Box
        data-testid={testID ? `${testID}` : undefined}
        ref={ref}
        component={component}
        {...rest}
      >
        {children}
      </Box>
    );
  }
);

export default EDBox;
